// Using mutation keys make it easier to identify the mutation in the
// TanStack Query devtools.
export const MUTATION_KEYS = {
  acceptCommercialAgreementTemplate: () => [
    'accept-commercial-agreement-template',
  ],
  acceptCommercialAgreementTemplateRevision: () => [
    'accept-commercial-agreement-template-revision',
  ],
  createClientReferral: () => ['create-client-referral'],
  createCommercialAgreementTemplatePdfPreview: () => [
    'create-commercial-agreement-template-pdf-preview',
  ],
  createReferral: () => ['create-referral'],
  createReferralInvite: () => ['create-referral-invite'],
  createEmailPreviewAndUserMessage: () => ['email-preview-and-user-message'],
  createOrUpdateClient: () => ['create-or-update-client'],
  createReferralEmailPreview: () => ['create-referral-email-preview'],
  createExistingAdviserReferralMetadata: () => [
    'create-existing-adviser-referral-metadata',
  ],
  createNewAdviserReferralMetadata: () => [
    'create-new-adviser-referral-metadata',
  ],
  refreshExistingAdviserMetadataAndProceed: () => [
    'refresh-existing-adviser-metadata-and-proceed',
  ],
  requestCallback: () => ['request-callback'],
  requestCommercialAgreementTemplateAmendment: () => [
    'request-commercial-agreement-template-amendment',
  ],
  requestReferralDiscoveryAccess: () => ['request-referral-discovery-access'],
  selectReferralFirm: () => ['select-referral-firm'],
  sessionMetadata: () => ['session-metadata'],
  importIntellifloQueueRecords: () => ['import-intelliflo-queue-records'],
  resolveIntellifloOutboundReview: () => ['resolve-intelliflo-outbound-review'],
  startIntellifloPendingUploads: () => ['start-intelliflo-pending-uploads'],
  liftClientRedaction: (referralId: number) => [
    'lift-client-redaction',
    referralId,
  ],
  updateIntellifloIntegration: () => ['update-intelliflo-integration'],
  validatePhoneNumber: () => ['validate-phone-number'],
}
